module.exports = __webpack_public_path__ + "img/44.21832959.png";